import React, { useState, useEffect, useContext } from 'react';
import {Text, Tabs, LegacyCard, FormLayout} from '@shopify/polaris';
import { FormProvider, FormContext, useReducerTab } from '@thinkwell/react.common'
import { TextField } from '@thinkwell/react.polaris'
import PasswordForm from './PasswordForm'

export default function AssignedForm(props) {
  const form = useContext(FormContext)
  const label = props.label || 'Student'
  const tabs = [
    {
      id: 'existing',
      content: `Existing ${label}`
    },
    {
      id: 'new',
      content: `New ${label}`
    }
  ];
  if(props.withSelf) {
    tabs.unshift({
      id: 'self',
      content: 'Yourself'
    })
  }

  const [state, onTabSelected] = useReducerTab(props, tabs, props.tabSelected)

  const data = {
    self: {
      type: 'self'
    },
    existing: {
      type: 'existing'
    },
    new: {
      type: 'new'
    }
  }
  return (
    <LegacyCard>
      <FormProvider scope={state.tabSelected} data={data} parent={form} name="assignedForm">
      <Tabs fitted
        tabs={tabs}
        selected={state.tabIndexSelected}
        onSelect={(tab) => {props.onTabSelected && props.onTabSelected(tab); onTabSelected(tab)}}>
        { state.tabSelected == 'self' ? (
          <LegacyCard.Section><Text>Click Save button to assign this Course to your own account.</Text></LegacyCard.Section>
        ) : null }
        { state.tabSelected == 'existing' ? (<div>
          <TextField required
            label="Email / Username"
            name="email"
          />
        </div>) : null }
        { state.tabSelected == 'new' ? (<div>
          <FormLayout>
            <TextField required
              label="Email / Username"
              name="email"
            />
            <FormLayout.Group>
              <TextField required
                label="First name"
                name="first_name"
              />
              <TextField required
                label="Last name"
                name="last_name"
              />
            </FormLayout.Group>
            <PasswordForm withConfirmation />
          </FormLayout>
        </div>) : null }
      </Tabs>
      </FormProvider>
    </LegacyCard>
  );
}
